import { render, staticRenderFns } from "./source_tree.vue?vue&type=template&id=5d3a1324&scoped=true"
import script from "./source_tree.vue?vue&type=script&setup=true&lang=js"
export * from "./source_tree.vue?vue&type=script&setup=true&lang=js"
import style0 from "./source_tree.vue?vue&type=style&index=0&id=5d3a1324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a1324",
  null
  
)

export default component.exports